class HorizontalNavigation {
  constructor() {
    this.nav = document.querySelector('.horizontal-nav');
    this.links = document.querySelectorAll('.horizontal-nav__link');
    this.container = document.querySelector('.horizontal-nav__container');
    
    if (!this.nav || !this.links.length) return;
    
    this.init();
  }
  
  init() {
    this.setupEventListeners();
    this.updateActiveStates();
    this.setupSmoothScrolling();
  }
  
  setupEventListeners() {
    // Handle link clicks
    this.links.forEach(link => {
      link.addEventListener('click', (e) => {
        this.handleLinkClick(e, link);
      });
    });
    
    // Handle scroll events for mobile
    if (this.nav) {
      this.nav.addEventListener('scroll', this.throttle(() => {
        this.updateScrollIndicators();
      }, 100));
    }
    
    // Handle window resize
    window.addEventListener('resize', this.throttle(() => {
      this.updateScrollIndicators();
    }, 250));
  }
  
  handleLinkClick(e, link) {
    // Remove active class from all links
    this.links.forEach(l => l.classList.remove('is-active'));
    
    // Add active class to clicked link
    link.classList.add('is-active');
    
    // Scroll to center the active link on mobile
    this.scrollToActiveLink(link);
  }
  
  scrollToActiveLink(activeLink) {
    if (!this.nav || !this.container) return;
    
    const navRect = this.nav.getBoundingClientRect();
    const linkRect = activeLink.getBoundingClientRect();
    const containerRect = this.container.getBoundingClientRect();
    
    // Calculate scroll position to center the link
    const linkCenter = linkRect.left + (linkRect.width / 2);
    const navCenter = navRect.left + (navRect.width / 2);
    const scrollOffset = linkCenter - navCenter;
    
    // Smooth scroll to position
    this.nav.scrollBy({
      left: scrollOffset,
      behavior: 'smooth'
    });
  }
  
  updateActiveStates() {
    // Check if any link matches current URL
    const currentPath = window.location.pathname;
    
    this.links.forEach(link => {
      const href = link.getAttribute('href');
      if (href && href !== '#' && currentPath.includes(href)) {
        link.classList.add('is-active');
      }
    });
  }
  
  updateScrollIndicators() {
    // Add visual indicators for scrollable content
    if (!this.nav) return;
    
    const isScrollable = this.nav.scrollWidth > this.nav.clientWidth;
    const isAtStart = this.nav.scrollLeft <= 0;
    const isAtEnd = this.nav.scrollLeft >= (this.nav.scrollWidth - this.nav.clientWidth);
    
    this.nav.classList.toggle('is-scrollable', isScrollable);
    this.nav.classList.toggle('is-at-start', isAtStart);
    this.nav.classList.toggle('is-at-end', isAtEnd);
  }
  
  setupSmoothScrolling() {
    // Add smooth scrolling behavior
    if (this.nav) {
      this.nav.style.scrollBehavior = 'smooth';
    }
  }
  
  // Utility function to throttle events
  throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new HorizontalNavigation();
});

// Re-initialize on page navigation (for SPA-like behavior)
document.addEventListener('shopify:section:load', () => {
  new HorizontalNavigation();
});
